import Link from 'next/link'
import { Text } from '@pancakeswap/uikit'
import Shell from 'views/TradingCompetitionV3/components/Shell'
import { ContractContext } from 'views/TradingCompetitionV3/contract'
import List from 'views/TradingCompetitionV3/List'
import { V4_BINDING } from 'views/TradingCompetitionV4/binding'
import { V4_ENABLED } from 'views/TradingCompetitionV4/config'

// Feature flag: without NEXT_PUBLIC_COMPETITION_V4_ADDRESS the page says so and links to V3.
const Page = () =>
  V4_ENABLED ? (
    <ContractContext.Provider value={V4_BINDING}>
      <List />
    </ContractContext.Provider>
  ) : (
    <Shell title="Competitions" subtitle="">
      <Text data-testid="v4-off">
        Competition V4 is not live yet. <Link href="/trading-competition-v3" style={{ textDecoration: 'underline' }}>See the current competitions</Link>.
      </Text>
    </Shell>
  )
Page.chains = []

export default Page
